import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Polygon as LeafletPolygon, ZoomControl } from 'react-leaflet'
import * as turf from '@turf/turf'
import 'leaflet/dist/leaflet.css'
import L, { LatLng } from 'leaflet'
import type { Feature, Polygon } from 'geojson'
import { calculoAreaCoord, getBoundsNoArray } from '../../../services/Afins'
import { kml } from '@tmcw/togeojson'
import { errorAlert } from '../../../utils/alert'
import { AjustarBounds, GridMalha, GridPolygon, MalhaGrid } from './components/gerarMalha'
import Configuracoes from './components/config'
import { calcularCentroTurf, criarPoligono } from './meta'

// Corrigir ícone padrão do Leaflet
delete (L.Icon.Default as any).prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
})

const GridMap = () => {
  const [kmlComCruzamento, setKmlComCruzamento] = useState(null)
  const [disable, setDisable] = useState(true)
  const [validoFile, setValidoFile] = useState(false)
  const [area, setArea] = useState([])

  //GRID
  const [rotation, setRotation] = useState<number>(0)
  const [movendo, setMovendo] = useState<boolean>(false)
  const [areaHa, setAreaHa] = useState<number>(0)
  const [gridLevel, setGridLevel] = useState<string>('')
  const [position, setPosition] = useState<{ x: 0; y: 0 }>({ x: 0, y: 0 })
  const [grid, setGrid] = useState<GridMalha[]>([])
  const [gridOriginal, setGridOriginal] = useState<GridMalha[]>([])
  const [gridOriginalRotacao, setGridOriginalRotacao] = useState<GridMalha[]>([])
  const [malhaPolygon, setMalhaPolygon] = useState<GridPolygon[]>([])
  const [malhaPolygonOriginal, setMalhaPolygonOriginal] = useState<GridPolygon[]>([])
  const [tamanhoGridOriginal, setTamanhoGridOriginal] = useState<number>(0)
  const [abrirModal, setAbrirModal] = useState<boolean>(false)
  const [pontosSelecionados, setPontosSelecionados] = useState([])
  const [nomeTalhao, setNomeTalhao] = useState<string>('')
  const [clicou, setClicou] = useState<boolean>(false)
  const [mousePosition, setMousePosition] = useState<[number, number] | null>(null)

  //CONFIGURAÇÕES
  const [tab_container_atual, setTab_container_atual] = useState<string>('Mapa')
  const [novoPonto, setNovoPonto] = useState<boolean>(false)
  const [moverPonto, setMoverPonto] = useState<boolean>(false)
  const [removerPonto, setRemoverPonto] = useState<boolean>(false)
  const [selecionarPonto, setSelecionarPonto] = useState<boolean>(false)
  const [abaAtual, setAbaAtual] = useState<number>(0)
  const abasNome = ['Mapa', 'Pontos', 'Ordenacao']
  const [confirmado, setConfirmado] = useState<boolean>(false)
  const [arquivoSelecionado, setArquivoSelecionado] = useState<string>('')
  const [rotacaoInput, setRotacaoInput] = useState<string>('')
  const [reset, setReset] = useState(true)
  const [quadrante, setQuadrante] = useState<number>(0)

  const areateste = area?.map((item) => [item.lat, item.lng])
  const padrao = [
    [-15.7801, -47.9292],
    [-15.7801, -47.9192],
    [-15.7701, -47.9192],
    [-15.7701, -47.9292],
    [-15.7801, -47.9292],
  ]

  const kmlCoordsLatLng = area.length <= 0 ? padrao : areateste
  //@ts-ignore
  const ancora: LatLng | null = calcularCentroTurf(kmlCoordsLatLng)
  const polygonKml = criarPoligono(kmlCoordsLatLng)

  const handleFileUpload = (rawData: string, base64Data) => {
    extractCoordinates(rawData)
  }

  const parseXmlFromString = async (xmlString: string): Promise<Document> => {
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(xmlString, 'application/xml')
    return xmlDoc
  }

  const extractCoordinates = async (kmlString: string) => {
    try {
      const domKml = await parseXmlFromString(kmlString)

      const dataGeoJson = kml(domKml)
      setNomeTalhao(dataGeoJson?.features[0]?.properties?.name)
      const talhoes = []

      const dados = dataGeoJson.features
      const filtrado = dados.filter((data) => data.geometry.type === 'Polygon')

      if (filtrado.length > 0) {
        for (let i = 0; i < filtrado.length; i += 1) {
          const fragment = filtrado[i]
          const talhaoPoly = []

          const coordinates = fragment.geometry.coordinates[0]

          for (let ii = 0; ii < coordinates.length; ii += 1) {
            const coord = coordinates[ii]

            talhaoPoly.push({ lat: coord[1], lng: coord[0] })
          }

          talhoes.push(talhaoPoly)
        }

        const areaCoord = talhoes[0].map((item) => {
          return { lat: item.lat, lng: item.lng }
        })
        setArea(areaCoord)
        const calcArea = calculoAreaCoord([areaCoord])
        setAreaHa(calcArea)
        if (calcArea <= 0) {
          errorAlert('Arquivo Kml inválido!')
          setValidoFile(false)
          setTimeout(() => {
            setDisable(true)
          }, 1000)
        } else {
          setValidoFile(true)
          setTimeout(() => {
            setDisable(false)
          }, 1000)
        }
      } else {
        errorAlert('Arquivo kml inválido!')
        setValidoFile(false)
      }
    } catch (error) {
      console.error('Erro ao processar XML:', error)
    }
  }

  function verificarAvancar() {
    const temValor = grid.some((item) => 'posicao' in item)
    const tamanhoGrid = grid.filter(({ center }) =>
      turf.booleanPointInPolygon(turf.point([center[1], center[0]]), polygonKml)
    )
    if (temValor && abaAtual === 2) {
      return setAbrirModal(true)
    }

    if (tamanhoGridOriginal !== tamanhoGrid.length && abaAtual === 1) {
      return setAbrirModal(true)
    }

    voltar()
  }

  function avancar() {
    if (abaAtual < abasNome.length - 1) {
      setAbaAtual((prev) => prev + 1)
    }
  }

  function voltar() {
    if (abaAtual > 0) {
      setAbaAtual((prev) => prev - 1)
    }
  }

  function resetarGrid() {
    setReset(false)
    setGrid(gridOriginalRotacao)
    setPontosSelecionados([])
    setMousePosition(null)
  }

  useEffect(() => {
    if (confirmado) {
      if (abaAtual === 2) {
        voltar()
        setAbrirModal(false)
        setSelecionarPonto(false)
        resetarGrid()
        setArquivoSelecionado('')
        setTimeout(() => {
          setConfirmado(false)
        }, 500)
      }

      if (abaAtual === 1) {
        voltar()
        setAbrirModal(false)
        setGrid(gridOriginal)
        setRotation(0)
        setRotacaoInput('0')
        setNovoPonto(false)
        setMoverPonto(false)
        setRemoverPonto(false)
        setTimeout(() => {
          setConfirmado(false)
        }, 500)
      }
    }
  }, [confirmado])

  useEffect(() => {
    if (area.length > 0) {
      const kinks = turf.kinks(polygonKml)
      if (kinks.features.length > 0) {
        setKmlComCruzamento(true)
        return errorAlert('Contorno com linhas sobrepostas! Corrija o kml')
      }
      setGrid([])
      setGridOriginal([])
      setGridOriginalRotacao([])
      setTamanhoGridOriginal(null)
      setClicou(false)
      setRotation(0)
      setKmlComCruzamento(false)
    }
  }, [area])

  useEffect(() => {
    abasNome.forEach((item, index) => {
      if (index === abaAtual) {
        setTab_container_atual(item)
      }
    })

    if (abaAtual === 1) {
      setSelecionarPonto(false)
      setPontosSelecionados([])
    }

    if (abaAtual === 2) {
      setSelecionarPonto(true)
      setNovoPonto(false)
      setMoverPonto(false)
      setRemoverPonto(false)
    }
  }, [abaAtual])

  const center: [number, number] = [kmlCoordsLatLng[0][1], kmlCoordsLatLng[0][0]]
  return (
    <div style={{ display: 'flex', position: 'relative', overflow: 'hidden' }}>
      <Configuracoes
        disable={disable}
        setDisable={setDisable}
        handleFileUpload={handleFileUpload}
        validoFile={validoFile}
        setValidoFile={setValidoFile}
        rotation={rotation}
        setRotation={setRotation}
        rotacaoInput={rotacaoInput}
        setRotacaoInput={setRotacaoInput}
        movendo={movendo}
        setMovendo={setMovendo}
        novoPonto={novoPonto}
        setNovoPonto={setNovoPonto}
        moverPonto={moverPonto}
        setMoverPonto={setMoverPonto}
        removerPonto={removerPonto}
        setRemoverPonto={setRemoverPonto}
        selecionarPonto={selecionarPonto}
        setSelecionarPonto={setSelecionarPonto}
        gridLevel={gridLevel}
        setGridLevel={setGridLevel}
        position={position}
        setPosition={setPosition}
        tab_container_atual={tab_container_atual}
        setTab_container_atual={setTab_container_atual}
        arquivoSelecionado={arquivoSelecionado}
        setArquivoSelecionado={setArquivoSelecionado}
        setGrid={setGrid}
        setGridOriginal={setGridOriginal}
        setGridOriginalRotacao={setGridOriginalRotacao}
        setMalhaPolygon={setMalhaPolygon}
        setMalhaPolygonOriginal={setMalhaPolygonOriginal}
        setTamanhoGridOriginal={setTamanhoGridOriginal}
        setQuadrante={setQuadrante}
        setClicou={setClicou}
        areaHectares={areaHa}
        polygon={polygonKml}
        kmlComCruzamento={kmlComCruzamento}
        abaAtual={abaAtual}
        abasNome={abasNome}
        pontosSelecionados={pontosSelecionados}
        area={area}
        areaTamanho={areaHa}
        quadrante={quadrante}
        grid={grid}
        avancar={avancar}
        voltar={verificarAvancar}
        resetarGrid={resetarGrid}
        nomeTalhao={nomeTalhao}
      />

      <MapContainer
        center={center}
        zoom={15}
        style={{ height: '100vh', width: '100%', position: 'relative', overflow: 'hidden' }}
        zoomControl={false}
        preferCanvas={true}
      >
        {/* Usando mapa satélite */}
        <TileLayer
          url='http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
          subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        />
        <AjustarBounds coordenadas={area} />
        <MalhaGrid
          polygon={polygonKml}
          novoPonto={novoPonto}
          moverPonto={moverPonto}
          removerPonto={removerPonto}
          selecionarPonto={selecionarPonto}
          rotation={rotation}
          isSliding={movendo}
          gridLevel={Number(gridLevel.replace(',', '.'))}
          moverHorizontal={position?.x}
          moverVertical={position?.y}
          tab_selecionado={tab_container_atual}
          abaAtual={abaAtual}
          grid={grid}
          setGrid={setGrid}
          gridOriginal={gridOriginal}
          setGridOriginal={setGridOriginal}
          gridOriginalRotacao={gridOriginalRotacao}
          setGridOriginalRotacao={setGridOriginalRotacao}
          setTamanhoGridOriginal={setTamanhoGridOriginal}
          abrirModal={abrirModal}
          setAbrirModal={setAbrirModal}
          confirmado={confirmado}
          setConfirmado={setConfirmado}
          pontosSelecionados={pontosSelecionados}
          setPontosSelecionados={setPontosSelecionados}
          mousePosition={mousePosition}
          setMousePosition={setMousePosition}
          ancora={ancora}
        />

        {/* Mostra o polígono do KML */}
        <LeafletPolygon
          positions={kmlCoordsLatLng.map((coord) => [coord[0], coord[1]] as [number, number])}
          fillOpacity={0}
        />
        <ZoomControl position='topright' />
      </MapContainer>
    </div>
  )
}

export default GridMap
